import React, { useState } from "react";

import OutlinedInputCustom from "../utility/component/textInput";
import { DepartmentMasterHelp } from "../help";
import IssueBillHelp from "../help/issueHelp";

const PartyDetails = ({
  partyDetails,
  setPartyDetails,

  issueToRef,

  setVoucherHelpStatus,
  delayedFunction,
  rows,
}) => {
  return (
    <div className="flex h-auto w-auto py-2  ">
      <div
        style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
        className="pt-3 px-3 pb-3   bg-[#ffffff]"
      >
        <div className="-mt-7 bg-white text-[15px] font-semibold w-fit px-2">
          Vouhcer Details
        </div>
        <div className="grid grid-cols-[160px,190px]  d:grid-cols-[200px,150px,180px] gap-3 mt-3 w-full ">
          <OutlinedInputCustom
            readOnly={true}
            value={partyDetails.VOUCHER_NO}
            label={"Voucher No."}
            fontWeight={600}
            search={() => {
              setVoucherHelpStatus(true);
            }}
          />

          <OutlinedInputCustom
            type={"date"}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (/^\d{4}-\d{2}-\d{2}$/.test(inputValue)) {
                setPartyDetails((prevState) => ({
                  ...prevState,
                  DATE: inputValue,
                }));
              }
            }}
            value={partyDetails.DATE}
            label={"Date"}
          />
        </div>
      </div>

      <div
        style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
        className=" bg-white grid grid-cols-3 gap-3 p-3 flex-1 ml-3"
      >
        <div className="">
          <OutlinedInputCustom
            onChange={(e) => {
              setPartyDetails((o) => {
                return {
                  ...o,
                  VOUCHER_TYPE: e.target.value,
                };
              });
              delayedFunction(rows[0].id);
            }}
            width={`calc(100% - 0px)`}
            value={partyDetails.VOUCHER_TYPE}
            label={"Voucher type"}
            autoFocus={true}
            option={[
              {
                name: "Purchase",
                value: "Purchase",
              },
              {
                name: "Contra",
                value: "Contra",
              },

              {
                name: "Credit Note",
                value: "Credit Note",
              },
              {
                name: "Debit Note",
                value: "Debit Note",
              },
              {
                name: "Journal",
                value: "Journal",
              },
              {
                name: "Payment",
                value: "Payment",
              },
              {
                name: "Receipt",
                value: "Receipt",
              },
              {
                name: "Sale",
                value: "Sale",
              },
            ]}
          />
        </div>

        <OutlinedInputCustom
          width={`calc(100% - 0px)`}
          value={partyDetails.DOC_NO}
          label={"Doc No."}
          refrance={issueToRef}
          onChange={(e) => {
            setPartyDetails((p) => {
              return {
                ...p,
                DOC_NO: e.target.value,
              };
            });
          }}
        />
      </div>
    </div>
  );
};

export default PartyDetails;
